import { BaseCommon } from "./base-common.abstract";
export class BaseStoreBlock extends BaseCommon {
}
//# sourceMappingURL=base-block.abstract.js.map